// extracted by mini-css-extract-plugin
export default {"cardInfo":"CardInfo_cardInfo__D0Juo","card":"CardInfo_card__VN4FU","icon":"CardInfo_icon__pBJs9","changeCard":"CardInfo_changeCard__ShFpT"};